import validator from 'validator';
/* common for inputs to display "Required" on blur */
const onEmptyBlurValidator = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
v, { message = 'Required', trigger = ['onBlur', 'onInput'] } = {}) => ({
    invalid: () => typeof v !== 'string' || !v.length,
    message,
    trigger,
});
const asciiValidator = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
v, { message = 'Only Ascii characters are allowed', trigger = '', lowercase = false, } = {}) => ({
    invalid: () => !validator.isAscii(v) || (lowercase && /[A-Z]/.test(v)),
    message,
    trigger,
});
const urlValidator = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
v, { message = 'URL is invalid', trigger = '', options = {
    require_protocol: true,
    protocols: ['http', 'https'],
    allow_underscores: true,
}, } = {}) => ({
    invalid: () => !validator.isURL(v, { ...options }),
    message,
    trigger,
});
const emailValidator = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
v, { message = 'Invalid email address', trigger = ['onBlur', 'onInput'] } = {}) => ({
    invalid: () => v !== '' && !validator.isEmail(v),
    message,
    trigger,
});
const phoneValidator = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
v, { message = 'Invalid phone number', trigger = ['onBlur', 'onInput'] } = {}) => ({
    invalid: () => v !== '' && !validator.isMobilePhone(v),
    message,
    trigger,
});
const integerValidator = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
v, { message = 'Must be a whole number', trigger = ['onBlur', 'onInput'] } = {}) => ({
    invalid: () => !validator.isInt(String(v)),
    message,
    trigger,
});
const getConfirmPassValidator = (otherValue) => (thisValue) => {
    const r1 = onEmptyBlurValidator(thisValue);
    const r2 = {
        message: 'Passwords do not match.',
        invalid: () => thisValue !== otherValue,
        trigger: ['onBlur', 'onInput'],
    };
    return [r1, r2];
};
const getMinMaxValidator = ({ min, max, trigger = ['onBlur', 'onInput'], }) => (v) => {
    const isGreaterThanMax = Number(v) > max;
    const isLessThanMin = Number(v) < min;
    const isLessThanMax = Number(v) < max;
    const r1 = onEmptyBlurValidator(v, { trigger });
    const r2 = integerValidator(v, { trigger });
    const r3 = isLessThanMax
        ? {
            message: `Must be ${min} or greater`,
            invalid: () => isLessThanMin,
            trigger,
        }
        : {
            message: `Must be ${max} or less`,
            invalid: () => isGreaterThanMax,
            trigger,
        };
    return [r1, r2, r3];
};
export { onEmptyBlurValidator, asciiValidator, urlValidator, emailValidator, phoneValidator, integerValidator, getConfirmPassValidator, getMinMaxValidator, };
